import { useEffect, useState } from "react";
import { useTheme } from "./ThemeContext";

const MainImage = () => {
  const { image: themeImage } = useTheme();
  const [image, setImage] = useState(themeImage);

  /* UPDATE IMAGE WHEN THEME CHANGES */
  useEffect(() => {
    setImage(themeImage);
  }, [themeImage]);

  return (
    <div className="relative w-full">
      <div className="relative w-full max-h-[500px] overflow-hidden shadow-lg">
        <img src={image} alt="Hero" className="w-full h-[500px] object-cover" />

        {/* DARK OVERLAY */}
        <div className="absolute inset-0 bg-black/50" />

        {/* HERO TEXT */}
        <div className="absolute bottom-0 left-0 mr-[45px] bg-black/50 rounded p-1">
          <h1 className="text-center text-xl sm:text-2xl md:text-3xl font-bold text-yellow-300">
            Welcome To Prophet Kevin Online Official Website
          </h1>
          <p className="text-center text-sm sm:text-base text-white font-semibold mt-1">
            For Divine Messages, Teachings, visions sharing, live broadcasting and more. This platform is to keep you connected, spiritually uplifted and rooted in Christ.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MainImage;
